<template>
    <div class="table">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes">
          <div class="contianer">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
              <el-form-item label="测评编号" prop="generatedIds">
                 <el-tag class="tag" v-for="(item,index) in form.students" :key="index" v-if="item.generatedId">{{ item.nickname }}:{{ item.generatedId }}</el-tag>
              </el-form-item>
              <el-form-item label="测评日期" prop="date1">
                <el-date-picker type="date" v-model="form.date1" placeholder="选择日期" :editable="false" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="测评时间" prop="date2">
                <el-time-picker arrow-control v-model="form.date2" placeholder="选择时间" format="HH:mm:ss" :editable="false" style="width: 100%;"></el-time-picker>
              </el-form-item>
              <el-form-item label="主测老师" prop="region1">
                 <el-input v-model="form.region1" maxlength="10" readonly></el-input>
              </el-form-item>
              <el-form-item label="受测者" prop="region2">
                 <el-select v-model="form.region2" multiple style="width: 100%;">
                  <el-option v-for="item in form.students" :key="item.index" :label="item.nickname" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input v-model="form.desc" type="textarea" maxlength="300" placeholder="输入备注内容"></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-button type="primary" @click="saveEvalua('form')">保存测评</el-button><!-- <router-link to="/student?tab=second">保存测评</router-link> -->
                <el-button type="primary" class="goto" @click="navigateToEvalua">进入测评</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
    </div>
</template>
<script>
import { getUserList, saveEvalua } from '@/api/app'
export default {
  name: 'Table',
  data () {
    return {
      column: '3-18周岁测评',
      form: {
        number: '',
        region1: '',
        region2: [],
        students: [],
        date1: new Date(),
        date2: new Date(),
        desc: ''
      },
      rules: {
        date1: [
          { required: true, message: '请选择测评日期', trigger: 'blur' }
        ],
        date2: [
          { required: true, message: '请选择测评时间', trigger: 'blur' }
        ],
        region1: [
          { required: true, message: '请输入测试老师', trigger: 'blur' }
        ]/* ,
        region2: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ] */
      },
      generatedIds: [], // 存储生成的编号
      sequenceNumber: 0 // 递增序列号
    }
  },
  watch: {
    'form.region2' (newVal, oldVal) {
      console.log('newVal', newVal)
      console.log('oldVal', oldVal)
      // Add new items
      newVal.forEach(item => {
        if (!oldVal.includes(item)) {
          this.generatedIds.push({ item, id: this.generateId() })
        }
        // console.log('=====newVal===>', this.form.students)
        for (let key in this.form.students) {
          // console.log('item=======', item)
          if (item * 1 === this.form.students[key].id * 1) {
            this.form.students[key]['generatedId'] = this.generateId()
            // console.log('=====newVal===>', this.form.students[key])
          }
        }
      })
      // Remove old items
      oldVal.forEach(item => {
        if (!newVal.includes(item)) {
          const index = this.generatedIds.findIndex(obj => obj.item === item)
          if (index !== -1) {
            this.generatedIds.splice(index, 1)
            for (let key in this.form.students) {
              // console.log('item=======', item)
              if (item * 1 === this.form.students[key].id * 1) {
                this.form.students[key]['generatedId'] = ''
                // console.log('=====newVal===>', this.form.students[key])
              }
            }
          }
        }
      })
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      const params = {
        page_no: 1,
        page_size: 2000,
        status: [5, 8]
      }
      // 设置老师名字
      this.form.region1 = ''
      this.form.students = (await getUserList(params)).lists
      if(this.form.students){
        this.form.region1 = this.form.students[0].adminInfo.name || ''
      }      
      // console.log('students====', this.form.region1)
    },
    goBack () {
      this.$router.go(-1)
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    saveEvalua (formName) {
      let that = this
      that.$refs[formName].validate((valid) => {
          if (valid) {
            if (that.form.region2.length === 0) {
              // 如果没有选择任何值，提示用户
              this.$message.error('请选择受测者')
              return
            }
            // console.log(this.form.students[0].generatedId)
            const waitOk = saveEvalua(this.form)
            // console.log(waitOk)
            waitOk.then(function (data) {
                // 在这里处理数据
                // console.log('===client:==', data)
                let rMap = {}
                for (let key2 in that.form.region2) {
                  rMap['id_' + that.form.region2[key2]] = 1
                }
                let nameStr = []
                let selectedId = []
                for (let key in that.form.students) {
                  if (rMap['id_' + that.form.students[key]['id']]) {
                    nameStr.push(that.form.students[key]['nickname'])
                    selectedId.push(that.form.students[key]['id'])
                  }
                }
                that.$router.push({
                  name: 'evalua',
                  query: { selected: selectedId.join(','), nameStr: nameStr.join(',') }
                })
                // that.$router.push('/Evalua') // goBack()
                // that.loadingInstance && that.loadingInstance.close()
            }).catch(function (error) {
                // 在这里处理错误3
                console.log('===error:==', error)
            })
          } else {
            console.log('error submit!!')
            return false
          }
      })
      /**/
    },
    generateId () {
      const prefix = 'YUE004A181045'
      const date = new Date()
      const year = date.getFullYear().toString()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const dateString = `${year}${month}${day}`

      // 更新递增序列号
      this.sequenceNumber += 1
      const sequenceString = this.sequenceNumber.toString().padStart(3, '0')

      // 生成完整编号
      const generatedId = `${prefix}-${dateString}-${sequenceString}`

      // 将序列号保存到 localStorage
      localStorage.setItem('sequenceNumber', this.sequenceNumber)

      return generatedId
    },
    navigateToEvalua () {
      /* if (this.form.region2.length > 0) {
        this.$router.push({
          name: 'evalua',
          query: { selected: this.form.region2.join(',') }
        })
      } else {
        // 如果没有选择任何值，提示用户
        this.$message.error('请选择受测者')
      } */
      this.saveEvalua('form')
    }
  },
  created () {
    // 从 localStorage 中读取序列号
    const storedSequenceNumber = localStorage.getItem('sequenceNumber')
    if (storedSequenceNumber !== null) {
      this.sequenceNumber = parseInt(storedSequenceNumber, 10)
    }
  }
}
</script>
<style>
.table{
  min-height: 100vh;
  /* background: #efefef; */
}
.table .avatar {
  width: 100%;
  background: linear-gradient(90deg, #ff9b00, #accd05);
  padding: 1rem 0;
}
.table .avatar .dfx{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table .avatar .column{
  flex: 1;
  text-align: center;
  font-size: 1.13rem;
  font-weight: bold;
  color: #fff;
}
.table .asstes .contianer{
  margin: 5% 23% 5%;
  padding-bottom: 68px;
}
.table .asstes .el-form{
  width: 100%;
  background: #fff;
  border-radius: 1.13rem;
  border: none;
  /* padding: 0.94rem 1.13rem; */
}
.table .asstes .el-form .el-form-item{
  border-bottom:1px solid #dedede;
  margin-bottom: 0;
}
.table .asstes .el-form .el-form-item .el-form-item__label{
  width: 6.2rem !important;
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 4rem;
  text-align: left;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: #000;
}
.table .asstes .el-form .el-form-item .el-form-item__label::before{
  position: absolute;
  top: 0;
  right: -3px;
}
/* .table .asstes .el-form .el-form-item .el-form-item__label::after{
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
  line-height: 4rem;
} */
.table .asstes .el-form .el-form-item .el-form-item__content{
  margin-left: 6.2rem !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 4rem;
  gap: 6px;
  /* overflow: hidden; */
}
.table .asstes .el-form .el-form-item .el-form-item__content::before,
.table .asstes .el-form .el-form-item .el-form-item__content::after{
  display: none;
}
.table .asstes .el-form .el-form-item .el-form-item__content .el-tag{
    background-color: #f9f9f9;
    border-color: #ddd;
    color: #333;
}
.table .asstes .el-form .el-form-item .el-form-item__content  .el-input{
  line-height: 4rem;
}
.table .asstes .el-form .btn .el-form-item__content{
  text-align: center;
}
.table .asstes .el-form .el-form-item .el-form-item__content .el-textarea{
  padding-top: .8rem;
}
.table .asstes .el-form .el-form-item .el-form-item__content .el-button{
    width: 10.13rem;
    height: 2rem;
    border: 0;
    padding: 0;
    margin-top: 2.5rem;
}
.table .asstes .el-form .el-form-item .el-form-item__content .el-button span,
.table .asstes .el-form .el-form-item .el-form-item__content .el-button span a{
  display: block;
  line-height: 2rem;
}
.table .asstes .el-form .el-form-item .el-form-item__content .el-button span a{
  font-size: 1rem;
  color: #fff;
}
.table .asstes .el-form .el-form-item .el-form-item__content .el-button--primary{
  background: linear-gradient(0deg,#81B337,#ACCD05);
}
.table .asstes .el-form .el-form-item.btn .el-form-item__content .goto{
  background: linear-gradient(0deg,#FF9C00,#FF7200);
  font-size: 1rem;
  color: #fff;
}
.table .asstes .el-form .btn .el-form-item__content{
  overflow: visible;
}
.table .asstes .el-form .el-input__inner,
.table .asstes .el-form .el-textarea__inner{
  border:0;
}
.table .asstes .el-form .btn{
  border-bottom:  0;
}
.table .asstes .el-form .btn .el-form-item__content{
  margin-left: 0 !important;
}

@media (max-width:1024px) {
 .table .asstes .contianer {
  margin: 5% auto 5%;
 }
}
</style>



// WEBPACK FOOTER //
// src/views/Table.vue